module.exports = __webpack_public_path__ + "img/Welcome 2.c96deb96.png";